<template>
  <el-drawer class="menu-group-drawer" :visible.sync="visible" direction="ltr" :modal='false' :size='200' append-to-body>
    <el-menu class="el-menu-vertical-demo" text-color="#666666" :unique-opened="true" :collapse-transition="false" :default-openeds="openeds">
      <el-submenu v-for="item in menuGroup" :key="item.id" :index="item.id">
        <template slot="title">
          <span>{{item.name}}</span>
        </template>
        <template>
          <el-menu-item v-for="subItem in item.list" :key="subItem.id" :index="subItem.id" @click="hadleChangeHouseId(subItem)">
            <span slot="title">{{subItem.name}}</span>
          </el-menu-item>
        </template>
      </el-submenu>
    </el-menu>
  </el-drawer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      visible: false,
      openeds: []
    }
  },
  computed: { ...mapState({ menuGroup: state => state.user.menuGroup }) },
  created () {
    this.init()
  },
  methods: {
    init () {
      console.log(this.menuGroup)
      this.openeds = []
      this.menuGroup.forEach((item) => {
        this.openeds.push(item.id)
      })
      this.visible = true
    },
    hadleChangeHouseId (list) {
      let target = window.location.origin
      window.location.href = target + '?houseId=' + list.id
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer {
  // background: #F8FAFD;
  .el-drawer__header {
    padding: 12px;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    line-height: 22px;
  }
  .el-drawer__body {
    padding: 0;
    overflow: auto;
  }
}

::v-deep .el-drawer__container {
  border: none;
  outline: none;
  div.el-drawer {
    position: absolute;
    top: 60px;
    height: calc(100% - 60px);
  }
}
</style>
